<template>  
  <section>

     <b-overlay :show="loading" rounded="sm">
      <div class="form-group">
        <label class="col-form-label">{{
          $t("PASSWORD")
        }}</label>
        <input
          class="form-control inputTransparent"
          v-model="password" v-on:keyup.enter="loginSubmit"
          autocomplete="current-password"
          type="password"
          name="password"
          required
        />
      </div>

      <button
        :disabled="checkDisabled"
        v-on:click="loginSubmit"
        class="btn mt-2 btn-fill btn-block btn-primary"
      >
        {{ $t("LOGIN") }}
      </button>
      </b-overlay>

  </section>
</template>
<script>
export default {
  props: ["loginInfo"],
  data() {
    return {
      loading: true,
      password: '',
      errorMessage: ""
    };
  },
  methods: {
    loginSubmit: async function(event) {
      event.preventDefault();
      this.$emit("loading",true);
      this.loading = true;
      let self = this;
      this.$http
        .post(this.user.hostname + "/authenticate", {
          email: this.user.email,
          auth_type: this.loginInfo.auth_type,
          password: this.password,
          client: 'teams'
        })
        .then(function(result) {     
          self.$emit('authenticated',result.data.token);
        })
        .catch(function(error) {
          self.$emit("loading",false);
          self.loading = false;
          if(error.toString() == "Error: fail_4_4") return;
          self.$noty.error(self.$t("ERROR.CANNOT_LOGIN"));
        });
    }
  },
  computed: {
    checkDisabled: function() {
      return this.user.email == "" || this.password == "";
    }
  },
  mounted: function() {
    this.loading = false;
    this.loginInfo.auth_method = "";
  }
};
</script>
<style></style>
